// @vendors
const get = require('lodash/object/get');

// @actions
const signaturePatternActions = require('actions/signaturePattern');
const errorActions = require('actions/brokerError');

// @helpers
const apiURLBuilder = require('core/apiURLBuilder');
const { APIPost } = require('utilities/APIRequestHelper');

// @constants
const { FIRST_STEP } = require('constants/index');

const {
    BROKER_CASH_CHARGE_START,
    BROKER_CASH_CHARGE_CHANGE_TITLES_AMOUNT,
    BROKER_CASH_CHARGE_CHANGE_ACCEPT_INSTRUCTIONS,
    BROKER_CASH_CHARGE_VALIDATE_STEP,
    BROKER_CASH_CHARGE_SET_VISIBLE_STEP,
    BROKER_CASH_CHARGE_FINISH,
    BROKER_CASH_CHARGE_WILL_CANCEL
} = require('constants/actionTypes');

const start = (cuenta, operation, contract, owner, walletAccountType) => (dispatch) => {
    dispatch({
        type: BROKER_CASH_CHARGE_START,
        payload: {
            cuenta,
            operation,
            contract,
            owner,
            walletAccountType
        }
    });
};

const changeTitlesAmount = (titles) => (dispatch) => {
    dispatch({
        type: BROKER_CASH_CHARGE_CHANGE_TITLES_AMOUNT,
        payload: { titles }
    });
};

const changeAcceptInstructions = () => (dispatch) => {
    dispatch({
        type: BROKER_CASH_CHARGE_CHANGE_ACCEPT_INSTRUCTIONS,
        payload: {}
    });
};

const validateStep = (step) => (dispatch) => {
    dispatch({
        type: BROKER_CASH_CHARGE_VALIDATE_STEP,
        payload: { step }
    });
};

const setVisibleStep = (step) => (dispatch) => {
    dispatch({
        type: BROKER_CASH_CHARGE_SET_VISIBLE_STEP,
        payload: { step }
    });
};

const successOperation = (response) => {
    return {
        type: BROKER_CASH_CHARGE_FINISH,
        payload: {
            orderNumber: get(response, 'response.numInstruccion')
        }
    };
};

const performOperation = (dispatch, getState, token, history) => {
    const immBrokerCashCharge = getState().brokerCashCharge;
    const url = apiURLBuilder.getURL('brokerDividendosEleccion');
    const immBrokerLegalDocumentation = getState().brokerLegalDocumentation;
    const uuid = immBrokerLegalDocumentation.get('uuid');

    const requestData = {
        contratoValores: {
            numerodecontrato: immBrokerCashCharge.getIn(['contract', 'number']),
            producto: immBrokerCashCharge.getIn(['contract', 'product'])
        },
        dataToken: token,
        documentationId: uuid
    };

    APIPost(dispatch, url, { query: requestData }).then(
        (response) => dispatch(successOperation(response)),
        function(response) {
            const errorKey = get(response, ["body", "error"], "");
            dispatch(errorActions.show("brokerAPIErrors-" + errorKey, true, history));
        }
    );
};

const validateSignature = (dispatch, getState, history) => {
    signaturePatternActions.validateAndExecute(
        dispatch,
        getState,
        (dispatch, getState, token) => performOperation(dispatch, getState, token, history)
    );
};

const validate = (dispatch, getState, history) => {
    const immBrokerCashCharge = getState().brokerCashCharge;
    const url = apiURLBuilder.getURL('brokerDividendosEleccionValidacion');

    const requestData = {
        contratoValores: {
            numerodecontrato: immBrokerCashCharge.getIn(['contract', 'number']),
            producto: immBrokerCashCharge.getIn(['contract', 'product'])
        },
        titulos: immBrokerCashCharge.getIn(['steps', FIRST_STEP, 'titlesAmount'])
    };

    APIPost(dispatch, url, { query: requestData }).then(
        () => validateSignature(dispatch, getState, history),
        function(response) {
            const errorKey = get(response, ["body", "error"], "");
            dispatch(errorActions.show("brokerAPIErrors-" + errorKey, true, history));
        }
    );
};

const finish = (history) => (dispatch, getState) => {
    validate(dispatch, getState, history);
};

const setWillCancel = (willCancel) => ({
    type: BROKER_CASH_CHARGE_WILL_CANCEL,
    payload: {
        willCancel
    }
});

module.exports = {
    start,
    changeTitlesAmount,
    changeAcceptInstructions,
    validateStep,
    setVisibleStep,
    setWillCancel,
    finish
};
